import RedirectRequestPayment from '@model/redirect-request-payment';

export function generateUniqueUID(data: RedirectRequestPayment, productName: string): string {
  const date = new Date();
  const timestamp = date.getTime().toString();

  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  const randomSuffix = array[0].toString().padStart(5, '0');

  const token = randomSuffix + timestamp;
  return `${token}_${data.loanId}_${productName}`;
}
